import login from './login';

export default {
  language: 'ru',
  country: 'ru',
  name: 'Русский',
  embeddedLocale: login,
  flags: ['RU'],
};
